import RulesPageDefault from "../../../../components/Rules/RulesPageDefault";

export default function() {
    return (
        <div>
            <RulesPageDefault title="C. Playing the Game"/>
        </div>
    )
}